module.exports = __webpack_public_path__ + "static/media/treeswing.0339e53e.svg";